import React, { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useTracker } from '../../context/TrackerContext';
import { saveCrmSession } from '../../crm/session';
import { forgetCrmMe } from '../../crm/ui';

// The admin menu's "Sales CRM": opens the separate CRM site (/crm) already
// signed in as admin. Old links (/tracker/admin/crm/<tab>) land on the same page there.
// (old names like 'waiting' or 'history' are sent on to their tab by the CRM site)
const PAGE: Record<string, string> = { leads: 'leads', add: 'add', waiting: 'waiting', team: 'team', rules: 'rules', history: 'history' };

const AdminCrm: React.FC = () => {
  const { tab } = useParams();
  const { session } = useTracker();
  const navigate = useNavigate();
  const adminPassword = session?.kind === 'admin' ? session.adminPassword : '';
  useEffect(() => {
    if (!adminPassword) return;
    forgetCrmMe();
    saveCrmSession({ kind: 'admin', name: 'Admin', role: 'Admin', isManager: true, takesLeads: false, adminPassword });
    navigate(`/crm/${PAGE[tab || ''] || 'home'}`, { replace: true });
  }, [adminPassword, tab, navigate]);
  if (!adminPassword) return <Navigate to="/crm/login" replace />;
  return null;
};

export default AdminCrm;
